import VillaDetailsSection from './VillaDetailsSection';

export default VillaDetailsSection;
